module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADsSURBVEhL7c2xscIwFERRO3HknAbowD1QBGXgNiiDJuiBDmiAGCISmZV0h+GNkLFsMjgzmg/svv3Vb3HO7fzj6/cMw1BreK+/AZ9r4mU01GjwEJZf8FtDJwgHJXTTaugYz1NkbfxW+A90vNLNKZ6OenY4/Uzja70zd5NxPk69TuOXeFKsY+Y9DW/0rpSL6fbmN5izFGz17nRn8xt+i9lIP/R6js5ifkt65i06szGTR282ZvLoGUQJYoMoj55BlCA2iPLoGUQJYoMoj55BlCA2iPLoGUQJYoMoj55BlCA2iPLoGUQJYoPob6qqegDJq5ctTKjDuAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-home/light/24.png
// module id = 2154
// module chunks = 2